import React, { useEffect, useState } from "react";
import { Form, Button, Container, Row, Col, Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import {
  faEye,
  faEyeSlash,
  faUser,
  faEnvelope,
  faPhone,
  faMapMarkerAlt,
  faBriefcase,
  faGlobe,
  faVenusMars,
  faIdCard,
  faCalendarAlt,
  faLock,
  faCheckSquare,
  faArrowRight,
  faUsers,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import "./Subscription.css";
import { apiRequest } from "../../services";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import {useDispatch} from "react-redux";

const InsuranceForm = () => {
  const dispatch = useDispatch()
  const [step, setStep] = useState(1);
  const [viewpassword, setViewPassword] = useState(false);
  const [guardianUnderageError, setGuardianUnderageError] = useState(false);
  const [token, setToken] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [notification, setNotification] = useState(null);

  const [formError, setFormError] = useState({
    confirmPassword: null,
    password: null,
    dateOfBirth: null,
    gender: null,
    nationality: null,
    maritalStatus: null,
    occupation: null,
    address: null,
    phoneNumber: null,
    fullName: null,
    email: null,
    cniNumber: null,
    language: null,
    cniIssueDate: null,
    cniExpiryDate: null,
    acceptTerms: null,
    cniPlaceOfIssue: null,
  });

  const [formData, setFormData] = useState({
    confirmPassword: "",
    password: "",
    dateOfBirth: "",
    gender: "",
    acceptTerms: false,
    nationality: "",
    maritalStatus: "",
    occupation: "",
    address: "",
    phoneNumber: "",
    fullName: "",
    email: "",
    cniNumber: "",
    language: "",
    cniIssueDate: "",
    cniExpiryDate: "",
    cniPlaceOfIssue: "",
    subscriptionChannel: "WEB",
  });

  const resetForm = () => {
    setFormData({
      confirmPassword: "",
      password: "",
      dateOfBirth: "",
      gender: "",
      acceptTerms: false,
      nationality: "",
      maritalStatus: "",
      occupation: "",
      address: "",
      phoneNumber: "",
      fullName: "",
      email: "",
      cniNumber: "",
      language: "",
      cniIssueDate: "",
      cniExpiryDate: "",
      cniPlaceOfIssue: "",
      subscriptionChannel: "WEB",
    });
    setFormError({
      confirmPassword: null,
      password: null,
      dateOfBirth: null,
      gender: null,
      nationality: null,
      maritalStatus: null,
      occupation: null,
      address: null,
      phoneNumber: null,
      fullName: null,
      email: null,
      cniNumber: null,
      language: null,
      cniIssueDate: null,
      cniExpiryDate: null,
      acceptTerms: null,
      cniPlaceOfIssue: null,
    });
    setStep(1);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const requestData = {
          password: "notRegister",
          userNameOrEmail: "notRegister",
        };
        const response = await apiRequest(
          "LOGIN",
          "TechCareAuthentification/login",
          "POST",
          requestData,
          null,
          dispatch,
          navigate
        );
        if (response && response.status === 200) {
          setToken(response.body.data.token);
        }
      } catch (error) {
        console.error("Erreur lors de la requête de connexion :", error);
        toast.error(t("failedToFetchToken"));
      }
    };
    fetchData();
  }, [t]);

  const handleNavigateProfil = () => {
    navigate(`/`);
  };

  const validateOnInputChange = (fieldName, currentFormData) => {
    const errors = {};
    switch (fieldName) {
      case "fullName":
        errors.fullName = !currentFormData.fullName
          ? t("requiredField")
          : currentFormData.fullName.length < 3
          ? t("fullNameTooShort")
          : null;
        break;
      case "confirmPassword":
        errors.confirmPassword = !currentFormData.confirmPassword
          ? t("requiredField")
          : currentFormData.confirmPassword !== currentFormData.password
          ? t("passwordsDoNotMatch")
          : null;
        break;
      case "password":
        errors.password = !currentFormData.password
          ? t("requiredField")
          : currentFormData.password.length !== 5
          ? t("Votre mot de passe doit avoir 5 chiffres")
          : null;
        if (currentFormData.confirmPassword) {
          errors.confirmPassword =
            currentFormData.confirmPassword !== currentFormData.password
              ? t("passwordsDoNotMatch")
              : null;
        }
        break;
      case "dateOfBirth":
        errors.dateOfBirth = !currentFormData.dateOfBirth
          ? t("requiredField")
          : guardianUnderageError
          ? t("underageAge")
          : null;
        break;
      case "gender":
        errors.gender = !currentFormData.gender ? t("requiredField") : null;
        break;
      case "nationality":
        errors.nationality = !currentFormData.nationality
          ? t("requiredField")
          : null;
        break;
      case "maritalStatus":
        errors.maritalStatus = !currentFormData.maritalStatus
          ? t("requiredField")
          : null;
        break;
      case "occupation":
        errors.occupation = !currentFormData.occupation
          ? t("requiredField")
          : null;
        break;
      case "address":
        errors.address = !currentFormData.address ? t("requiredField") : null;
        break;
      case "email":
        errors.email = !currentFormData.email
          ? t("requiredField")
          : !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(currentFormData.email)
          ? t("invalidEmail")
          : null;
        break;
      case "cniIssueDate":
        errors.cniIssueDate = !currentFormData.cniIssueDate
          ? t("requiredField")
          : null;
        break;
      case "language":
        errors.language = !currentFormData.language ? t("requiredField") : null;
        break;
      case "cniExpiryDate":
        errors.cniExpiryDate = !currentFormData.cniExpiryDate
          ? t("requiredField")
          : null;
        break;
      case "cniPlaceOfIssue":
        errors.cniPlaceOfIssue = !currentFormData.cniPlaceOfIssue
          ? t("requiredField")
          : null;
        break;
      case "phoneNumber":
        errors.phoneNumber = !currentFormData.phoneNumber
          ? t("requiredField")
          : currentFormData.phoneNumber.length !== 9
          ? t("votre télephone doit contenir 9 chiffres")
          : null;
        break;
      case "cniNumber":
        errors.cniNumber = !currentFormData.cniNumber
          ? t("requiredField")
          : null;
        break;
      case "acceptTerms":
        errors.acceptTerms = !currentFormData.acceptTerms
          ? t("youMustAcceptTerms")
          : null;
        break;
      default:
        break;
    }
    return errors;
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const inputValue = type === "checkbox" ? checked : value;
    const updatedFormData = { ...formData, [name]: inputValue };
    setFormData(updatedFormData);
    const errors = validateOnInputChange(name, updatedFormData);
    setFormError((prev) => ({ ...prev, ...errors }));
  };

  const handleIssueDateChange = (date) => {
    const formattedDate = date ? dayjs(date).format("YYYY-MM-DD") : "";
    const updatedFormData = { ...formData, cniIssueDate: formattedDate };
    setFormData(updatedFormData);
    const errors = validateOnInputChange("cniIssueDate", updatedFormData);
    setFormError((prev) => ({ ...prev, ...errors }));
  };

  const handleIssueDateOfBirthChange = (date) => {
    const formattedDate = date ? dayjs(date).format("YYYY-MM-DD") : "";
    const updatedFormData = { ...formData, dateOfBirth: formattedDate };
    setFormData(updatedFormData);
    handleBenefGuardiandateChange(formattedDate);
    const errors = validateOnInputChange("dateOfBirth", updatedFormData);
    setFormError((prev) => ({ ...prev, ...errors }));
  };

  const handleChangePhoneNumber = (e) => {
    const { name, value } = e.target;
    const newValueWithoutSpaces = value.replace(/\s/g, "");
    const updatedFormData = { ...formData, [name]: newValueWithoutSpaces };
    setFormData(updatedFormData);
    const errors = validateOnInputChange(name, updatedFormData);
    setFormError((prev) => ({ ...prev, ...errors }));
  };

  const handleBenefGuardiandateChange = (date) => {
    if (!date) return;
    const guardianAge = dayjs().diff(dayjs(date), "year");
    const isUnderage = guardianAge < 18;
    setGuardianUnderageError(isUnderage);
    if (isUnderage) {
      setFormError((prev) => ({
        ...prev,
        dateOfBirth: t("invalidDateGuardian"),
      }));
    } else {
      setFormError((prev) => ({
        ...prev,
        dateOfBirth: validateOnInputChange("dateOfBirth", formData).dateOfBirth,
      }));
    }
  };

  const handleExpiryDateChange = (date) => {
    const formattedDate = date ? dayjs(date).format("YYYY-MM-DD") : "";
    const updatedFormData = { ...formData, cniExpiryDate: formattedDate };
    setFormData(updatedFormData);
    const errors = validateOnInputChange("cniExpiryDate", updatedFormData);
    setFormError((prev) => ({ ...prev, ...errors }));
  };

  const nextStep = () => {
    const errors = {};
    const fieldsToValidate = [
      step === 1
        ? ["fullName"]
        : step === 2
        ? ["dateOfBirth", "gender", "nationality", "maritalStatus"]
        : step === 3
        ? ["occupation", "address", "phoneNumber", "email"]
        : step === 4
        ? ["language"]
        : step === 5
        ? ["cniIssueDate", "cniExpiryDate", "cniNumber", "cniPlaceOfIssue"]
        : step === 6
        ? ["password", "confirmPassword"]
        : [],
    ].flat();

    fieldsToValidate.forEach((field) => {
      const fieldErrors = validateOnInputChange(field, formData);
      Object.assign(errors, fieldErrors);
    });

    setFormError(errors);
    if (
      Object.values(errors).some(
        (error) => error !== null && error !== undefined
      )
    ) {
      // toast.warning(t("formInvalid"));
      return;
    }
    setStep(step + 1);
  };

  const toggleSubmitCreateAccount = async () => {
    try {
      const errors = {};
      Object.keys(formError).forEach((field) => {
        const fieldErrors = validateOnInputChange(field, formData);
        Object.assign(errors, fieldErrors);
      });

      setFormError(errors);

      if (
        Object.values(errors).some(
          (error) => error !== null && error !== undefined
        )
      ) {
        // toast.warning(t("formInvalid"));
        return;
      }

      if (!token) {
        toast.error(t("noTokenAvailable"));
        return;
      }

      setLoading(true);
      const requestData = {
        serviceReference: "INITIATE_SUBSCRIRPTION_CLIENT_WEB",
        requestBody: JSON.stringify(formData),
      };

      const response = await apiRequest(
        "GATEWAY",
        "",
        "POST",
        requestData,
        token,
        dispatch,
        navigate
      );

      if (
        response &&
        response.status === 200 &&
        response.body.meta.statusCode === 200
      ) {
        setNotification({
          type: "success",
          message: t("successfulInitiateSubsription"),
        });
        //toast.success(t("successfulInitiateSubsription"));
        resetForm();
      }
    } catch (error) {
      // toast.error(t("submissionFailed"));
      console.log("error is ", error);
    } finally {
      setLoading(false);
    }
    setTimeout(() => setNotification(null), 20000);
  };

  const togglePassword = (event) => {
    event.preventDefault();
    setViewPassword(!viewpassword);
  };

  const renderStep = () => {
    switch (step) {
      case 1:
        return (
          <Row className="inscriptions-form-grid">
            <Col md={12}>
              <Form.Group className="inscriptions-form-group">
                <Form.Label className="inscriptions-label">
                  <FontAwesomeIcon icon={faUser} className="me-2" />
                  {t("fullName")}
                </Form.Label>
                <Form.Control
                  type="text"
                  name="fullName"
                  className={`inscriptions-input ${
                    formError.fullName ? "is-invalid" : ""
                  }`}
                  value={formData.fullName}
                  onChange={handleChange}
                  placeholder={t("enterFullName")}
                  required
                />
                {formError.fullName && (
                  <div className="inscriptions-invalid-feedback">
                    {formError.fullName}
                  </div>
                )}
              </Form.Group>
            </Col>
          </Row>
        );
      case 2:
        return (
          <Row className="inscriptions-form-grid">
            <Col md={12}>
              <Form.Group className="inscriptions-form-group">
                <Form.Label className="inscriptions-label">
                  <FontAwesomeIcon icon={faCalendarAlt} className="me-2" />
                  {t("dateOfBirth")}
                </Form.Label>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    className={`inscriptions-input ${
                      formError.dateOfBirth ? "is-invalid" : ""
                    }`}
                    value={
                      formData.dateOfBirth
                        ? dayjs(formData.dateOfBirth, "YYYY-MM-DD")
                        : null
                    }
                    onChange={handleIssueDateOfBirthChange}
                    format="YYYY-MM-DD"
                    disableFuture
                  />
                </LocalizationProvider>
                {formError.dateOfBirth && (
                  <div className="inscriptions-invalid-feedback">
                    {formError.dateOfBirth}
                  </div>
                )}
              </Form.Group>
            </Col>
            <Col md={12}>
              <Form.Group className="inscriptions-form-group">
                <Form.Label className="inscriptions-label">
                  <FontAwesomeIcon icon={faVenusMars} className="me-2" />
                  {t("gender")}
                </Form.Label>
                <Form.Control
                  as="select"
                  name="gender"
                  className={`inscriptions-input ${
                    formError.gender ? "is-invalid" : ""
                  }`}
                  value={formData.gender}
                  onChange={handleChange}
                  required
                >
                  <option value="">{t("selectGender")}</option>
                  <option value="Male">{t("male")}</option>
                  <option value="Female">{t("female")}</option>
                </Form.Control>
                {formError.gender && (
                  <div className="inscriptions-invalid-feedback">
                    {formError.gender}
                  </div>
                )}
              </Form.Group>
            </Col>
            <Col md={12}>
              <Form.Group className="inscriptions-form-group">
                <Form.Label className="inscriptions-label">
                  <FontAwesomeIcon icon={faGlobe} className="me-2" />
                  {t("nationality")}
                </Form.Label>
                <Form.Control
                  as="select"
                  name="nationality"
                  className={`inscriptions-input ${
                    formError.nationality ? "is-invalid" : ""
                  }`}
                  value={formData.nationality}
                  onChange={handleChange}
                  required
                >
                  <option value="">{t("selectNationality")}</option>
                  <option value="Cameroon">{t("Cameroon")}</option>
                </Form.Control>
                {formError.nationality && (
                  <div className="inscriptions-invalid-feedback">
                    {formError.nationality}
                  </div>
                )}
              </Form.Group>
            </Col>
            <Col md={12}>
              <Form.Group className="inscriptions-form-group">
                <Form.Label className="inscriptions-label">
                  <FontAwesomeIcon icon={faUser} className="me-2" />
                  {t("maritalStatus")}
                </Form.Label>
                <Form.Control
                  as="select"
                  name="maritalStatus"
                  className={`inscriptions-input ${
                    formError.maritalStatus ? "is-invalid" : ""
                  }`}
                  value={formData.maritalStatus}
                  onChange={handleChange}
                  required
                >
                  <option value="" disabled>
                    {t("selectStatus")}
                  </option>
                  <option value="Single">{t("single")}</option>
                  <option value="Married">{t("married")}</option>
                  <option value="Divorced">{t("divorced")}</option>
                  <option value="Widowed">{t("widowed")}</option>
                </Form.Control>
                {formError.maritalStatus && (
                  <div className="inscriptions-invalid-feedback">
                    {formError.maritalStatus}
                  </div>
                )}
              </Form.Group>
            </Col>
          </Row>
        );
      case 3:
        return (
          <Row className="inscriptions-form-grid">
            <Col md={12}>
              <Form.Group className="inscriptions-form-group">
                <Form.Label className="inscriptions-label">
                  <FontAwesomeIcon icon={faBriefcase} className="me-2" />
                  {t("occupation")}
                </Form.Label>
                <Form.Control
                  type="text"
                  name="occupation"
                  className={`inscriptions-input ${
                    formError.occupation ? "is-invalid" : ""
                  }`}
                  value={formData.occupation}
                  onChange={handleChange}
                  placeholder={t("occupationPlaceholder")}
                  required
                />
                {formError.occupation && (
                  <div className="inscriptions-invalid-feedback">
                    {formError.occupation}
                  </div>
                )}
              </Form.Group>
            </Col>
            <Col md={12}>
              <Form.Group className="inscriptions-form-group">
                <Form.Label className="inscriptions-label">
                  <FontAwesomeIcon icon={faMapMarkerAlt} className="me-2" />
                  {t("address")}
                </Form.Label>
                <Form.Control
                  type="text"
                  name="address"
                  className={`inscriptions-input ${
                    formError.address ? "is-invalid" : ""
                  }`}
                  value={formData.address}
                  onChange={handleChange}
                  placeholder={t("addressPlaceholder")}
                  required
                />
                {formError.address && (
                  <div className="inscriptions-invalid-feedback">
                    {formError.address}
                  </div>
                )}
              </Form.Group>
            </Col>
            <Col md={12}>
              <Form.Group className="inscriptions-form-group">
                <Form.Label className="inscriptions-label">
                  <FontAwesomeIcon icon={faPhone} className="me-2" />
                  {t("phoneNumber")}
                </Form.Label>
                <Form.Control
                  type="tel"
                  name="phoneNumber"
                  className={`inscriptions-input ${
                    formError.phoneNumber ? "is-invalid" : ""
                  }`}
                  value={formData.phoneNumber}
                  onChange={handleChangePhoneNumber}
                  placeholder={t("enterPhoneNumber")}
                  required
                />
                {formError.phoneNumber && (
                  <div className="inscriptions-invalid-feedback">
                    {formError.phoneNumber}
                  </div>
                )}
              </Form.Group>
            </Col>
            <Col md={12}>
              <Form.Group className="inscriptions-form-group">
                <Form.Label className="inscriptions-label">
                  <FontAwesomeIcon icon={faEnvelope} className="me-2" />
                  {t("email")}
                </Form.Label>
                <Form.Control
                  type="text"
                  name="email"
                  className={`inscriptions-input ${
                    formError.email ? "is-invalid" : ""
                  }`}
                  value={formData.email}
                  onChange={handleChange}
                  placeholder={t("enterEmail")}
                  required
                />
                {formError.email && (
                  <div className="inscriptions-invalid-feedback">
                    {formError.email}
                  </div>
                )}
              </Form.Group>
            </Col>
          </Row>
        );
      case 4:
        return (
          <Row className="inscriptions-form-grid">
            <Col md={12}>
              <Form.Group className="inscriptions-form-group">
                <Form.Label className="inscriptions-label">
                  <FontAwesomeIcon icon={faGlobe} className="me-2" />
                  {t("language")}
                </Form.Label>
                <Form.Control
                  as="select"
                  name="language"
                  className={`inscriptions-input ${
                    formError.language ? "is-invalid" : ""
                  }`}
                  value={formData.language}
                  onChange={handleChange}
                  required
                >
                  <option value="">{t("selectLanguage")}</option>
                  <option value="french">{t("french")}</option>
                  <option value="english">{t("english")}</option>
                </Form.Control>
                {formError.language && (
                  <div className="inscriptions-invalid-feedback">
                    {formError.language}
                  </div>
                )}
              </Form.Group>
            </Col>
          </Row>
        );
      case 5:
        return (
          <Row className="inscriptions-form-grid">
            <Col md={12}>
              <Form.Group className="inscriptions-form-group">
                <Form.Label className="inscriptions-label">
                  <FontAwesomeIcon icon={faCalendarAlt} className="me-2" />
                  {t("enterIdIssueDate")}
                </Form.Label>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    className={`inscriptions-input ${
                      formError.cniIssueDate ? "is-invalid" : ""
                    }`}
                    value={
                      formData.cniIssueDate
                        ? dayjs(formData.cniIssueDate, "YYYY-MM-DD")
                        : null
                    }
                    onChange={handleIssueDateChange}
                    format="YYYY-MM-DD"
                    disableFuture
                  />
                </LocalizationProvider>
                {formError.cniIssueDate && (
                  <div className="inscriptions-invalid-feedback">
                    {formError.cniIssueDate}
                  </div>
                )}
              </Form.Group>
            </Col>
            <Col md={12}>
              <Form.Group className="inscriptions-form-group">
                <Form.Label className="inscriptions-label">
                  <FontAwesomeIcon icon={faCalendarAlt} className="me-2" />
                  {t("enterIdExpiryDate")}
                </Form.Label>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    className={`inscriptions-input ${
                      formError.cniExpiryDate ? "is-invalid" : ""
                    }`}
                    value={
                      formData.cniExpiryDate
                        ? dayjs(formData.cniExpiryDate, "YYYY-MM-DD")
                        : null
                    }
                    onChange={handleExpiryDateChange}
                    format="YYYY-MM-DD"
                  />
                </LocalizationProvider>
                {formError.cniExpiryDate && (
                  <div className="inscriptions-invalid-feedback">
                    {formError.cniExpiryDate}
                  </div>
                )}
              </Form.Group>
            </Col>
            <Col md={12}>
              <Form.Group className="inscriptions-form-group">
                <Form.Label className="inscriptions-label">
                  <FontAwesomeIcon icon={faIdCard} className="me-2" />
                  {t("idnumber")}
                </Form.Label>
                <Form.Control
                  type="text"
                  name="cniNumber"
                  className={`inscriptions-input ${
                    formError.cniNumber ? "is-invalid" : ""
                  }`}
                  value={formData.cniNumber}
                  onChange={handleChange}
                  placeholder={t("idnumber")}
                  required
                />
                {formError.cniNumber && (
                  <div className="inscriptions-invalid-feedback">
                    {formError.cniNumber}
                  </div>
                )}
              </Form.Group>
            </Col>
            <Col md={12}>
              <Form.Group className="inscriptions-form-group">
                <Form.Label className="inscriptions-label">
                  <FontAwesomeIcon icon={faMapMarkerAlt} className="me-2" />
                  {t("cniPlaceOfIssue")}
                </Form.Label>
                <Form.Control
                  type="text"
                  name="cniPlaceOfIssue"
                  className={`inscriptions-input ${
                    formError.cniPlaceOfIssue ? "is-invalid" : ""
                  }`}
                  value={formData.cniPlaceOfIssue}
                  onChange={handleChange}
                  placeholder={t("enterIdPlaceOfIssue")}
                  required
                />
                {formError.cniPlaceOfIssue && (
                  <div className="inscriptions-invalid-feedback">
                    {formError.cniPlaceOfIssue}
                  </div>
                )}
              </Form.Group>
            </Col>
          </Row>
        );
      case 6:
        return (
          <Row className="inscriptions-form-grid">
            <Col md={12}>
              <Form.Group className="inscriptions-form-group">
                <Form.Label className="inscriptions-label">
                  <FontAwesomeIcon icon={faLock} className="me-2" />
                  {t("password")}
                </Form.Label>
                <div className="inscriptions-password-wrapper">
                  <Form.Control
                    type={viewpassword ? "text" : "password"}
                    name="password"
                    className={`inscriptions-input ${
                      formError.password ? "is-invalid" : ""
                    }`}
                    value={formData.password}
                    onChange={handleChange}
                    required
                    placeholder={t("enterPassword")}
                  />
                  <FontAwesomeIcon
                    icon={viewpassword ? faEye : faEyeSlash}
                    className="inscriptions-password-icon"
                    onClick={togglePassword}
                  />
                  {formError.password && (
                    <div className="inscriptions-invalid-feedback">
                      {formError.password}
                    </div>
                  )}
                </div>
              </Form.Group>
            </Col>
            <Col md={12}>
              <Form.Group className="inscriptions-form-group">
                <Form.Label className="inscriptions-label">
                  <FontAwesomeIcon icon={faLock} className="me-2" />
                  {t("confirmPassword")}
                </Form.Label>
                <div className="inscriptions-password-wrapper">
                  <Form.Control
                    type={viewpassword ? "text" : "password"}
                    name="confirmPassword"
                    className={`inscriptions-input ${
                      formError.confirmPassword ? "is-invalid" : ""
                    }`}
                    value={formData.confirmPassword}
                    onChange={handleChange}
                    required
                    placeholder={t("confirmPassword")}
                  />
                  <FontAwesomeIcon
                    icon={viewpassword ? faEye : faEyeSlash}
                    className="inscriptions-password-icon"
                    onClick={togglePassword}
                  />
                  {formError.confirmPassword && (
                    <div className="inscriptions-invalid-feedback">
                      {formError.confirmPassword}
                    </div>
                  )}
                </div>
              </Form.Group>
            </Col>
          </Row>
        );
      case 7:
        return (
          <Row className="inscriptions-form-grid">
            <Col md={12}>
              <Form.Group className="inscriptions-form-group">
                <Form.Check
                  type="checkbox"
                  id="acceptTerms"
                  label={t("conditionText")}
                  className={`inscriptions-checkbox ${
                    formError.acceptTerms ? "is-invalid" : ""
                  }`}
                  checked={formData.acceptTerms}
                  onChange={(e) =>
                    handleChange({
                      target: {
                        name: "acceptTerms",
                        type: "checkbox",
                        checked: e.target.checked,
                      },
                    })
                  }
                  required
                />
                {formError.acceptTerms && (
                  <div className="inscriptions-invalid-feedback">
                    {formError.acceptTerms}
                  </div>
                )}
              </Form.Group>
            </Col>
          </Row>
        );
      default:
        return null;
    }
  };

  return (
    <div className="inscriptions-container">
      <Container className="inscriptions-wrapper">
        {notification && (
          <div
            className={`account-notification account-notification-${notification.type}`}
          >
            <p>{notification.message}</p>
            {notification.type === "success" && (
              <button
                className="account-notification-button"
                onClick={handleNavigateProfil}
              >
                {t("Profil")}
              </button>
            )}
            <button
              className="account-notification-close"
              onClick={() => setNotification(null)}
            >
              ✕
            </button>
          </div>
        )}
        {/* <div className="inscriptions-header">
          <div className="inscriptions-overlay-text animate__animated animate__fadeIn">{t("subscriptionNow")}</div>
        </div> */}
        <div className="inscriptions-welcome">
          <FontAwesomeIcon
            icon={faUsers}
            className="inscriptions-welcome-icon animate__animated animate__bounceIn"
          />
          <h2 className="inscriptions-welcome-title">
            {t("titreInscription")}
          </h2>
          <p className="inscriptions-welcome-text">
            {t("sousTitreInscription")}
          </p>
        </div>
        <div className="inscriptions-progress">
          <div className="inscriptions-progress-bar">
            <div
              className="inscriptions-progress-step"
              style={{ width: `${(step / 7) * 100}%` }}
            ></div>
          </div>
          <p className="inscriptions-step-text">Step {step} of 7</p>
        </div>
        <div className="inscriptions-form-section animate__animated animate__fadeInUp">
          {renderStep()}
          <div className="inscriptions-actions">
            {step > 1 && (
              <Button
                variant="secondary"
                className="inscriptions-btn inscriptions-back-btn"
                onClick={() => setStep(step - 1)}
                disabled={loading}
              >
                {t("back")}
              </Button>
            )}
            {step < 7 ? (
              <Button
                variant="primary"
                className="inscriptions-btn inscriptions-next-btn"
                onClick={nextStep}
                disabled={loading}
              >
                {loading ? (
                  <Spinner size="sm" />
                ) : (
                  <>
                    <FontAwesomeIcon icon={faArrowRight} className="me-2" />
                    {t("next")}
                  </>
                )}
              </Button>
            ) : (
              <Button
                variant="success"
                className="inscriptions-btn inscriptions-submit-btn"
                onClick={toggleSubmitCreateAccount}
                disabled={loading || !formData.acceptTerms}
              >
                {loading ? (
                  <Spinner size="sm" />
                ) : (
                  <>
                    <FontAwesomeIcon icon={faCheckSquare} className="me-2" />
                    {t("signUp")}
                  </>
                )}
              </Button>
            )}
          </div>
        </div>
      </Container>
    </div>
  );
};

export default InsuranceForm;
